import { Navigate } from "react-router";
import {
  BasicRoutePath,
  CONTRACTOR_PAGE_ROOT_PATH,
  ContractorPage,
  SUB_CONTRACTOR_PAGE_ROOT_PATH,
  SubcontractorPage,
} from "@/constants";
import {
  HomePage,
  ApprovalsPage,
  // RequestsPage
} from "@/pages";
import { ContractorLayout } from "@/components/layout/contractor";
import {
  SubcontractorForm,
  // SubcontractorSearch,
  SubcontractorsList,
} from "@/pages/contractor-profile/subcontractor";
import { Contractors } from "@/pages/contractor-profile";
import { RequestsPage } from "@/pages/requests";
import { InboxKeyParam } from "@/pages/inbox/types";

export const routesBase = [
  {
    path: BasicRoutePath.Home,
    element: <HomePage />,
  },
  {
    path: BasicRoutePath.Approvals,
    element: <Navigate to={`${BasicRoutePath.Approvals}/:tab`} replace />,
  },
  {
    path: `${BasicRoutePath.Approvals}/:tab`,
    element: <ApprovalsPage />,
  },
  // {
  //   path: `${BasicRoutePath.Approvals}/:tab/:id`,
  //   element: <ApprovalsPage />,
  // },
  {
    path: BasicRoutePath.Requests,
    element: <RequestsPage />,
  },
  {
    path: `${BasicRoutePath.Requests}/edit`,
    element: <Navigate to={BasicRoutePath.Requests} replace />,
  },
  {
    path: `${BasicRoutePath.Requests}/edit/:${InboxKeyParam.ReferenceNumber}/:${InboxKeyParam.DomainId}`,
    element: <RequestsPage />,
  },
  {
    path: `${BasicRoutePath.Requests}/edit/:id`,
    element: <RequestsPage />,
  },
  {
    path: BasicRoutePath.ContractorProfile,
    element: (
      <Navigate to={`${CONTRACTOR_PAGE_ROOT_PATH}/${ContractorPage.Edit}`} />
    ),
  },
  {
    path: `${CONTRACTOR_PAGE_ROOT_PATH}`,
    element: (
      <Navigate to={`${CONTRACTOR_PAGE_ROOT_PATH}/${ContractorPage.Edit}`} />
    ),
  },
  {
    path: `${SUB_CONTRACTOR_PAGE_ROOT_PATH}`,
    element: (
      <Navigate
        to={`${SUB_CONTRACTOR_PAGE_ROOT_PATH}/${SubcontractorPage.List}`}
      />
    ),
  },
  {
    path: `${BasicRoutePath.ContractorProfile}/:tab/*`,
    element: <ContractorLayout />,
  },
];

export const contractorRoutes = [
  {
    path: ContractorPage.Edit,
    element: <Contractors />,
  },
  {
    path: SubcontractorPage.List,
    element: <SubcontractorsList />,
  },
  {
    path: SubcontractorPage.Edit,
    element: <SubcontractorForm />,
  },
  {
    path: `${BasicRoutePath.Requests}/edit`,
    element: <Navigate to={BasicRoutePath.Requests} replace />,
  },
  {
    path: `${SubcontractorPage.Edit}/:id`,
    element: <SubcontractorForm />,
  },
  // Disabled for now
  // {
  //   path: SubcontractorPage.Search,
  //   element: <SubcontractorSearch />,
  // },
];
